<template>
  <div>
    <!-- Filter Start -->
    <custom-filter :getFilterOnStart="true" @filterChange="changeFilter"></custom-filter>
    <!-- Filter End -->

    <!-- Chart Start -->
    <div class="row mt-4">
      <div class="col">
        <div class="innerBox">
          <div class="row">
            <div class="col-md-10">
              <h5 class="elegant--sub-title">
                Scan Activity
                <i class="fal fa-info-circle" id="average-scan-activity"></i>
                <b-popover target="average-scan-activity" triggers="hover" placement="top">
                  <template #title>Scan Activity</template>
                  {{ tooltip.scan_activity }}
                </b-popover>
              </h5>
            </div>
            <div class="col-md-2">
              <!-- v-model="filter.province_id" -->
              <MultiSelect v-model="selectedProvince" :options="options.provinces" placeholder="All Provinces" :select-label="''" :deselect-label="''" class="elegant-multiselect" @input="onProvinceChange" />
            </div>
            <!-- <p>Selected Province: {{ selectedProvince }}</p> -->
          </div>
          <scan-activity-chart v-if="data.scanActivityChart" :data="data.scanActivityChart" :filter="filter"></scan-activity-chart>
          <div v-else class="text-center mt-5 mb-5">
            <h2 class="pt-5 pb-5">Loading...</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- Chart End -->

    <!-- Customer Distribution Start -->
    <div class="innerBox mt-4" style="padding: 0; overflow: hidden">
      <h5 class="elegant--sub-title" style="padding: 10px 0 0px 15px">
        Customer Distribution
        <i class="fal fa-info-circle" id="customer-distribution"></i>
        (Last 1000 Scans)
        <b-popover target="customer-distribution" triggers="hover" placement="top">
          <template #title>Customer Distribution</template>
          {{ tooltip.customer_distribution }}
        </b-popover>
      </h5>
      <customer-distribution v-if="data.customerDistributionMap" :data="data.customerDistributionMap"></customer-distribution>
      <div v-else class="text-center mt-5 mb-5">
        <h2 class="pt-5 pb-5">Loading...</h2>
      </div>
    </div>
    <!-- Customer Distribution End -->

    <!-- Table Start -->
    <div class="innerBox mt-4">
      <div class="row">
        <!-- <div class="col-md-10"> -->
        <h5 class="elegant--sub-title">
          Scan History
          <i class="fal fa-info-circle" id="scan-history"></i>
          <b-popover target="scan-history" triggers="hover" placement="top">
            <template #title>Scan History</template>
            {{ tooltip.scan_history }}
          </b-popover>
        </h5>
        <!-- </div> -->
        <!-- <div class="col-md-2">
                    <MultiSelect 
                        v-model="vue_universal_table.filter.status"
                        :options="options.status"
                        placeholder="All Status"
                        class="elegant-multiselect"
                        />
                </div> -->

        <!-- v-model="filter.status" -->
        <!-- <div class="col-md-2"> -->
        <!-- </div> -->

        <!-- col-md-3  -->
        <div class="d-flex ml-auto">
          <MultiSelect v-model="vue_universal_table.filter.status" :options="options.status" placeholder="All Status" :select-label="''" :deselect-label="''" class="elegant-multiselect" style="width: 250px" @input="onStatusChange" />
          <button class="btn btn-elegant-download" @click="downloadScanHistoryExcel">
            Download Excel
            <i class="fas fa-download"></i>
          </button>
        </div>
      </div>
      <div class="mt-3 scan-history-table-wrapper">
        <!-- Loading State -->
        <div v-if="tableLoading" class="text-center mt-3 mb-3">
          <h4>Loading...</h4>
        </div>

        <!-- Table -->
        <div v-else style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table" style="margin: 0">
            <thead>
              <tr>
                <th>QR Code</th>
                <th>Product Name</th>
                <th>Volume</th>
                <th>Scan Date</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>Status</th>
                <th style="text-align: center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in scanHistoryData" :key="index">
                <td>{{ row.url || row.scan_qrcode || "N/A" }}</td>
                <td>{{ row.product_name || "N/A" }}</td>
                <td>{{ row.volume || "N/A" }}</td>
                <td>{{ row.scan_date || "N/A" }}</td>
                <td>{{ row.lat != 0 && row.lat != "N/A" ? row.lat : "N/A" }}</td>
                <td>{{ row.lng != 0 && row.lng != "N/A" ? row.lng : "N/A" }}</td>
                <td>{{ row.status || "N/A" }}</td>
                <td style="text-align: center">
                  <button v-if="row.lat != 'N/A' || row.lng != 'N/A'" class="btn btn-link" title="View Map" style="padding: 0; border: none; background: none" @click="viewScanMap(JSON.stringify(row))">
                    <img src="@/assets/CustomerActivities - Scan History Map Button.svg" alt="View Map" style="width: 34px; height: 24px; cursor: pointer" />
                  </button>
                  <span v-else>-</span>
                </td>
              </tr>
              <tr v-if="!tableLoading && scanHistoryData.length === 0">
                <td colspan="8" class="text-center">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mt-3" v-if="!tableLoading && (scanHistoryData.length > 0 || scanHistoryMaxPage > 0)">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="d-flex align-items-center">
              <label for="items-per-page" style="margin-right: 8px; margin-bottom: 0; color: #a3a4a6; font-size: 14px">View</label>
              <select id="items-per-page" v-model="scanHistoryLimitPerPage" @change="onLimitChange" class="form-control form-control-sm" style="width: auto; display: inline-block; padding: 4px 8px">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span style="margin-left: 8px; color: #a3a4a6; font-size: 14px">items per page</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <p class="mt-2 mb-2" style="color: #a3a4a6; margin-right: 20px; margin-bottom: 0">
                Showing {{ (scanHistoryCurrentPage - 1) * scanHistoryLimitPerPage + 1 }}-{{ scanHistoryCurrentPage * scanHistoryLimitPerPage < scanHistoryTotal ? scanHistoryCurrentPage * scanHistoryLimitPerPage : scanHistoryTotal }} of {{ displayedTotal }} Items
              </p>
              <nav class="pagination-minimal">
                <ul class="pagination" style="margin: 0; flex-wrap: wrap">
                  <li class="page-item" :class="{ disabled: scanHistoryCurrentPage <= 1 }" @click.stop.prevent="changePage('prev')">
                    <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                  </li>
                  <li class="page-item" :class="{ disabled: isOnLastPage }" @click.stop.prevent="changePage('next')">
                    <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Table End -->

    <!-- Modal Start -->
    <scan-map-modal v-if="modal.view" :coordinate="modal.viewData" @closeModal="modal.view = false"></scan-map-modal>
    <!-- Modal End -->
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import customFilter from "@/components/filter/customFilter";
import methods from "@/assets/mixin/methods";

import scanActivityChart from "./children/scanActivityChart.vue";
import customerDistribution from "./children/customerDistributionMap";

import scanMapModal from "./children/scanMapModal";

export default {
  mixins: [methods],
  metaInfo: {
    title: "Customer Activities",
  },
  data() {
    return {
      modal: {
        view: false,
        viewData: null,
      },
      filterStatus: null,
      provinces: [],
      selectedProvince: null,
      filter: {},
      data: {
        scanActivityChart: null,
        customerDistributionMap: null,
        scanHistory: null,
      },
      // Scan History Table Data
      scanHistoryData: [], // Currently displayed page data (from server)
      tableLoading: false,
      scanHistoryCurrentPage: 1,
      scanHistoryMaxPage: 1,
      scanHistoryTotal: 0,
      scanHistoryLimitPerPage: 5,
      // Add flag to prevent multiple API calls during initialization
      isInitializing: true,
      // Add debounce timer for fetchData
      fetchDataTimer: null,
      // Add debounce timer for changeFilter
      changeFilterTimer: null,
      // Track if we've received initial filter to prevent duplicate calls
      hasReceivedInitialFilter: false,
      // Track if we're currently fetching data
      isFetchingData: false,
      // Track if we've processed the initial filter to prevent duplicate calls
      hasProcessedInitialFilter: false,
      // Add unique component ID for debugging
      componentId: Math.random().toString(36).substr(2, 9),
      options: {
        // status: [
        //   "ACTIVATE",
        //   "DEACTIVATE",
        //   "Not Found",
        //   "Double Scan",
        //   "Cross Scan",
        //   "Reject",
        // ],
        provinces: [],
        status: ["ACTIVE", "INACTIVE"],
      },
      vue_universal_table: {
        fields: [
          { title: "QR Code", variable: "url" },
          { title: "Product Name", variable: "product_name" },
          { title: "Volume", variable: "volume" },
          { title: "Scan Date", variable: "scan_date" },
          { title: "Latitude", variable: "lat" },
          { title: "Longitude", variable: "lng" },
          { title: "Status", variable: "status" },
        ],
        filter: {
          region: null,
          status: null,
          start: moment().startOf("month").format("YYYY-MM-DD"),
          end: moment().format("YYYY-MM-DD"),
        },
        update: 0,
        buttons: [
          {
            title: "viewMap",
            class: "fas fa-location",
            condition: "data.lat != 'N/A' || data.lng != 'N/A'",
          },
        ],
        process_data: `
                        for (var i in data) {
                            data[i].url = data[i].url ? data[i].url : data[i].scan_qrcode
                            data[i].product_name = data[i].product_name ? data[i].product_name : 'N/A'
                            data[i].volume = data[i].volume ? (parseInt(data[i].volume))/1000 + ' Lt' : 'N/A'
                            data[i].lat = data[i].lat != 0 ? data[i].lat : 'N/A'
                            data[i].lng = data[i].lng != 0 ? data[i].lng : 'N/A'
                        }
                    `,
      },
      tooltip: this.$store.state.tooltip.customer_activities,
    };
  },
  components: {
    customFilter,
    // highlightStats,
    scanActivityChart,
    customerDistribution,
    scanMapModal,
  },
  mounted() {
    console.log(`CustomerActivities component mounted - ID: ${this.componentId}`);
    this.fetchMasterProvince();
  },
  beforeDestroy() {
    // Clear any pending timers
    if (this.fetchDataTimer) {
      clearTimeout(this.fetchDataTimer);
    }
    if (this.changeFilterTimer) {
      clearTimeout(this.changeFilterTimer);
    }
  },
  watch: {
    filter: {
      deep: true,
      handler(newVal, oldVal) {
        // Skip API calls during initialization to prevent multiple hits
        if (this.isInitializing) {
          return;
        }
        // Only call fetchData if filter actually changed (not just initialized)
        if (oldVal && Object.keys(oldVal).length > 0) {
          console.log("Filter watcher triggered - calling fetchData");
          this.fetchData();
        }
      },
    },
    // "filter.province_id"(newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     this.fetchData();
    //   }
    // },
    // "vue_universal_table.filter.status": {
    //   handler() {
    //     this.vue_universal_table.update++;
    //   },
    // },
    // Disabled status watcher to prevent duplicate table updates
    // All table updates are now handled through changeFilter method
    // "vue_universal_table.filter.status": function (newVal, oldVal) {
    //   // Status filter changes should only update the table, not trigger main fetchData
    //   if (newVal !== oldVal && !this.isInitializing && this.hasReceivedInitialFilter) {
    //     console.log("Status filter changed - updating table only", "oldVal:", oldVal, "newVal:", newVal);
    //     console.log("Incrementing vue_universal_table.update from", this.vue_universal_table.update, "to", this.vue_universal_table.update + 1);
    //     this.vue_universal_table.update++;
    //   } else {
    //     console.log("Status watcher triggered but skipped:", {
    //       newVal,
    //       oldVal,
    //       isInitializing: this.isInitializing,
    //       hasReceivedInitialFilter: this.hasReceivedInitialFilter
    //     });
    //   }
    // },
    "vue_universal_table.update": function (newVal, oldVal) {
      console.log("Table update changed from", oldVal, "to", newVal);
    },
  },
  computed: {
    hasMoreData() {
      // If we got a full page of data, there's likely more
      return this.scanHistoryData.length === this.scanHistoryLimitPerPage;
    },
    displayedTotal() {
      // Show cumulative total up to current page (capped at actual total)
      if (this.scanHistoryTotal === 0) {
        return "?";
      }
      return Math.min(this.scanHistoryCurrentPage * this.scanHistoryLimitPerPage, this.scanHistoryTotal);
    },
    isOnLastPage() {
      // If we're loading, don't disable the button
      if (this.tableLoading) {
        return false;
      }

      // With client-side pagination, we can directly check if we're on the last page
      // If we have no data at all, we're on the last (and only) page
      if (this.scanHistoryTotal === 0) {
        return true;
      }

      // Check if current page is at or beyond the last page
      return this.scanHistoryCurrentPage >= this.scanHistoryMaxPage;
    },
  },
  methods: {
    changeFilter(filter) {
      console.log(`changeFilter called - Component ID: ${this.componentId}, hasReceivedInitialFilter:`, this.hasReceivedInitialFilter, "isInitializing:", this.isInitializing, "hasProcessedInitialFilter:", this.hasProcessedInitialFilter);

      // Clear existing timer to debounce rapid calls
      if (this.changeFilterTimer) {
        clearTimeout(this.changeFilterTimer);
      }

      this.changeFilterTimer = setTimeout(() => {
        this.performChangeFilter(filter);
      }, 100); // 100ms debounce for changeFilter
    },
    performChangeFilter(filter) {
      console.log(`Performing changeFilter - Component ID: ${this.componentId}, filter:`, filter);

      // Update main filter object
      for (var i in filter) {
        this.$set(this.filter, i, filter[i]);
      }

      // Copy all filter properties to table filter except 'status' (which is handled separately)
      // and 'filter' (which is not needed by the table)
      for (var i in filter) {
        if (i !== "status" && i !== "filter") {
          this.$set(this.vue_universal_table.filter, i, filter[i]);
        }
      }

      // Ensure required parameters are always in table filter (especially dates)
      // Use $set to ensure reactivity - always update dates even if they appear the same
      if (filter.start !== undefined && filter.start !== null) {
        const currentStart = this.vue_universal_table.filter.start;
        if (currentStart !== filter.start) {
          console.log(`Date filter changed - start: ${currentStart} -> ${filter.start}`);
        }
        this.$set(this.vue_universal_table.filter, "start", filter.start);
        this.$set(this.filter, "start", filter.start);
      }
      if (filter.end !== undefined && filter.end !== null) {
        const currentEnd = this.vue_universal_table.filter.end;
        if (currentEnd !== filter.end) {
          console.log(`Date filter changed - end: ${currentEnd} -> ${filter.end}`);
        }
        this.$set(this.vue_universal_table.filter, "end", filter.end);
        this.$set(this.filter, "end", filter.end);
      }
      if (filter.region !== undefined) {
        this.$set(this.vue_universal_table.filter, "region", filter.region);
        this.$set(this.filter, "region", filter.region);
      }

      // Also copy province_id if present
      if (filter.province_id !== undefined) {
        this.$set(this.vue_universal_table.filter, "province_id", filter.province_id);
      }

      console.log("filter data from custom filter:", this.filter);
      console.log("table filter after update:", this.vue_universal_table.filter);

      // Mark that we've received initial filter
      if (!this.hasReceivedInitialFilter) {
        this.hasReceivedInitialFilter = true;
      }

      // Check if this is the first filter call (initial load)
      const isInitialFilter = !this.hasProcessedInitialFilter;
      if (isInitialFilter) {
        this.hasProcessedInitialFilter = true;
        console.log("Processing initial filter - calling APIs once");
        // Load table data on initial filter
        this.fetchScanHistory();
      } else {
        console.log("Processing subsequent filter change - updating table");
        // Always update table when filter changes
        this.scanHistoryCurrentPage = 1; // Reset to first page
        this.fetchScanHistory();
      }

      // Always fetch data when filter changes (but debounced)
      this.fetchData();
    },
    onProvinceChange(provinceName) {
      console.log("onProvinceChange triggered with:", provinceName);

      // Convert the selected province name to its corresponding ID
      const foundProvince = this.provinces.find((province) => province.nama_provinsi === provinceName);

      const filterProvinceId = foundProvince ? foundProvince.kode_provinsi : null;

      // Update the filter object with the converted ID
      this.$set(this.filter, "province_id", filterProvinceId);

      // Trigger fetchData (debounced)
      this.fetchData();
    },
    onStatusChange(statusValue) {
      console.log("onStatusChange triggered with:", statusValue);

      // Update table for status changes after initial load is complete
      if (!this.isInitializing && this.hasReceivedInitialFilter) {
        console.log("Status changed - updating table only");
        this.scanHistoryCurrentPage = 1; // Reset to first page
        this.fetchScanHistory();
      } else {
        console.log("onStatusChange: Skipped during initialization", {
          statusValue,
          isInitializing: this.isInitializing,
          hasReceivedInitialFilter: this.hasReceivedInitialFilter,
        });
      }
    },
    viewScanMap(data) {
      this.modal.viewData = JSON.parse(data);
      console.log("%cActivities.vue line:224 this.modal.viewData", "color: #007acc;", JSON.stringify(this.modal.viewData));
      this.modal.view = true;
    },
    // updateProvince() {
    //   // this.$set(this.filter, "province_id", province_id); // Ensure reactivity

    //   console.log(
    //     "Data provinsi from fetchData:",
    //     this.provinces[0].kode_provinsi
    //   );

    //   const filterProvinceId = this.provinces
    //     .filter((data) => data.nama_provinsi === this.filter.province_id)
    //     .map((province) => province.kode_provinsi)[0];
    //   console.log("filter id provinsi:", filterProvinceId);

    //   // this.filter.province_id = filterProvinceId || null;

    //   // this.filter = { ...this.filter, province_id: filterProvinceId || null };
    //   this.$set(this.filter, "province_id", filterProvinceId);
    //   console.log("filter data:", this.filter);
    // },
    fetchData() {
      console.log(`fetchData called - Component ID: ${this.componentId}`);
      // Clear existing timer to debounce rapid calls
      if (this.fetchDataTimer) {
        clearTimeout(this.fetchDataTimer);
      }

      this.fetchDataTimer = setTimeout(() => {
        this.performFetchData();
      }, 500); // 500ms debounce to handle rapid successive calls
    },
    performFetchData() {
      // Prevent concurrent API calls
      if (this.isFetchingData) {
        console.log(`Already fetching data, skipping... - Component ID: ${this.componentId}`);
        return;
      }

      // Prevent multiple instances from calling the same APIs simultaneously
      const filterKey = JSON.stringify(this.filter);
      console.log(`Checking global fetch flag for filter: ${filterKey} - Component ID: ${this.componentId}`);

      if (window.customerActivitiesFetching && window.customerActivitiesFetching[filterKey]) {
        console.log(`Another instance is already fetching data for this filter, skipping... - Component ID: ${this.componentId}`);
        return;
      }

      // Mark this filter as being fetched
      if (!window.customerActivitiesFetching) {
        window.customerActivitiesFetching = {};
      }
      window.customerActivitiesFetching[filterKey] = true;
      console.log(`Set global fetch flag for filter: ${filterKey} - Component ID: ${this.componentId}`);

      this.isFetchingData = true;
      console.log(`Performing fetchData - Component ID: ${this.componentId}, filter:`, this.filter);

      //Reset All Data to null
      for (var i in this.data) this.data[i] = null;

      //Remove filter from filter
      let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
      delete filterlessFilter.filter;

      // Create promises for both API calls
      const overviewPromise = this.$http.get(
        `/api/activities/overview?${qs.stringify(this.filter, {
          skipNulls: true,
          arrayFormat: "comma",
        })}`,
      );

      const mapDistributionPromise = this.$http.get(
        `/api/activities/map-distribution?${qs.stringify(filterlessFilter, {
          skipNulls: true,
          arrayFormat: "comma",
        })}`,
      );

      // Execute both API calls in parallel
      Promise.all([overviewPromise, mapDistributionPromise])
        .then(([overviewResp, mapResp]) => {
          this.data.scanActivityChart = overviewResp.data.data;
          this.data.customerDistributionMap = mapResp.data.data.filter((x) => x.lat != 0 && x.lng != 0);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isFetchingData = false;
          // Clear the global fetching flag
          if (window.customerActivitiesFetching && window.customerActivitiesFetching[filterKey]) {
            delete window.customerActivitiesFetching[filterKey];
            console.log(`Cleared global fetch flag for filter: ${filterKey} - Component ID: ${this.componentId}`);
          }
        });
    },
    async fetchMasterProvince() {
      console.log(`fetchMasterProvince called - Component ID: ${this.componentId}`);

      // Prevent multiple instances from calling the same API
      if (window.customerActivitiesProvinceLoaded) {
        console.log(`Province data already loaded, skipping API call - Component ID: ${this.componentId}`);
        // Use cached data if available
        if (window.cachedProvinceData) {
          const data = window.cachedProvinceData;
          const provincesData = data.map((province) => province.nama_provinsi);
          this.provinces = data;
          this.options.provinces = provincesData;
          this.isInitializing = false;
          return;
        }
      }

      window.customerActivitiesProvinceLoaded = true;
      const response = await this.$http.get("/api/master/provinsi");
      //   console.log("master provinsi data:", response);

      const data = response.data.data;
      const provincesData = data.map((province) => province.nama_provinsi);
      // const provincesIdData = data.map((province) => province.kode_provinsi);

      // Cache the data globally
      window.cachedProvinceData = data;

      this.provinces = data;
      this.options.provinces = provincesData;
      console.log("Data provinsi from fetchMasterProvince:", this.provinces);

      // Set initialization flag to false
      this.isInitializing = false;
    },
    downloadScanHistoryExcel() {
      // Only include start, end, status parameters
      let filterlessFilter = {};
      if (this.vue_universal_table.filter.start) {
        filterlessFilter.start = this.vue_universal_table.filter.start;
      }
      if (this.vue_universal_table.filter.end) {
        filterlessFilter.end = this.vue_universal_table.filter.end;
      }
      if (this.vue_universal_table.filter.status) {
        filterlessFilter.status = this.vue_universal_table.filter.status;
      }

      //Get all data for Excel export (no pagination)
      this.$http
        .get(`/api/activities/history?pagination=false&${qs.stringify(filterlessFilter, { skipNulls: true, arrayFormat: "comma" })}`)
        .then((resp) => {
          this.exportExcel(resp.data.data, "Scan History Download");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async fetchScanHistory() {
      this.tableLoading = true;

      // Build filter object from vue_universal_table.filter - only include start, end, status
      let filterlessFilter = {};
      if (this.vue_universal_table.filter.start) {
        filterlessFilter.start = this.vue_universal_table.filter.start;
      }
      if (this.vue_universal_table.filter.end) {
        filterlessFilter.end = this.vue_universal_table.filter.end;
      }
      if (this.vue_universal_table.filter.status) {
        filterlessFilter.status = this.vue_universal_table.filter.status;
      }

      console.log("fetchScanHistory - Current table filter:", this.vue_universal_table.filter);
      console.log("fetchScanHistory - Filterless filter:", filterlessFilter);

      try {
        const queryParams = {
          pagination: true,
          limit: this.scanHistoryLimitPerPage,
          page: this.scanHistoryCurrentPage,
          order: "DESC",
          by: "scan_date",
        };

        const url = `/api/activities/history?${qs.stringify({ ...queryParams, ...filterlessFilter }, { skipNulls: true, arrayFormat: "comma" })}`;

        console.log("fetchScanHistory - URL:", url);

        const resp = await this.$http.get(url);
        console.log("fetchScanHistory - Full response:", resp);
        console.log("fetchScanHistory - Response data:", resp.data);

        const rawData = resp.data.data || [];
        const meta = resp.data.meta || resp.data.pagination || resp.data || {};

        // Process this page's data - create a new array to ensure Vue reactivity
        const processedData = rawData.map((item) => {
          const processed = { ...item }; // Create new object
          processed.url = processed.url ? processed.url : processed.scan_qrcode;
          processed.product_name = processed.product_name ? processed.product_name : "N/A";
          // Convert volume from ml to liters (divide by 1000)
          processed.volume = processed.volume ? parseInt(processed.volume) / 1000 + " Lt" : "N/A";
          processed.lat = processed.lat != 0 ? processed.lat : "N/A";
          processed.lng = processed.lng != 0 ? processed.lng : "N/A";
          return processed;
        });

        this.$set(this, "scanHistoryData", processedData);

        const currentPage = meta.currentPage || meta.current_page || meta.page || this.scanHistoryCurrentPage || 1;
        let total = meta.total || meta.totalItems || meta.total_count || meta.totalRecords || meta.count || 0;
        let lastPage = meta.lastPage || meta.last_page || meta.totalPages || meta.total_pages || meta.maxPage || 0;

        if (total === 0) {
          if (processedData.length === this.scanHistoryLimitPerPage) {
            total = this.scanHistoryCurrentPage * this.scanHistoryLimitPerPage;
            lastPage = this.scanHistoryCurrentPage + 1;
          } else if (processedData.length > 0) {
            total = (this.scanHistoryCurrentPage - 1) * this.scanHistoryLimitPerPage + processedData.length;
            lastPage = this.scanHistoryCurrentPage;
          } else {
            total = 0;
            lastPage = 1;
          }
        } else if (total > 0) {
          if (!lastPage || lastPage === 0) {
            lastPage = Math.ceil(total / this.scanHistoryLimitPerPage);
          }
        }

        lastPage = Math.max(1, lastPage);

        if (processedData.length === this.scanHistoryLimitPerPage && this.scanHistoryCurrentPage >= lastPage) {
          lastPage = this.scanHistoryCurrentPage + 1;
        }

        this.$set(this, "scanHistoryCurrentPage", Number.parseInt(currentPage));
        this.$set(this, "scanHistoryMaxPage", Number.parseInt(lastPage));
        this.$set(this, "scanHistoryTotal", Number.parseInt(total));

        console.log("Server-side pagination result:", {
          currentPage: this.scanHistoryCurrentPage,
          lastPage: this.scanHistoryMaxPage,
          total: this.scanHistoryTotal,
          dataLength: this.scanHistoryData.length,
        });
      } catch (err) {
        console.log("Error fetching scan history:", err);
        this.$set(this, "scanHistoryData", []);
        this.$set(this, "scanHistoryCurrentPage", 1);
        this.$set(this, "scanHistoryMaxPage", 1);
        this.$set(this, "scanHistoryTotal", 0);
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      // Reset to first page when limit changes, then re-fetch from server
      this.$set(this, "scanHistoryCurrentPage", 1);
      this.fetchScanHistory();
    },
    changePage(opt) {
      if (this.tableLoading) {
        return;
      }

      let newPage = this.scanHistoryCurrentPage;

      if (opt === "prev") {
        newPage = Math.max(1, this.scanHistoryCurrentPage - 1);
      } else if (opt === "next") {
        // Use the computed property to check if we're on the last page
        if (this.isOnLastPage) {
          return; // Can't go to next page - we're on the last page
        }

        // Allow going to next page
        newPage = this.scanHistoryCurrentPage + 1;
      }

      if (newPage !== this.scanHistoryCurrentPage && newPage >= 1) {
        this.$set(this, "scanHistoryCurrentPage", newPage);
        this.fetchScanHistory();
      }
    },
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

/* Scan History Table Styles */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ffffff !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9d9d9d;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4b4b4b;
  text-align: left;
  vertical-align: middle;
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Pagination Styles - Minimalist */
.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4b4b4b;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled):hover .page-link {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9d9d9d !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}

::v-deep .popover-header {
  background-color: #ffffff;
  border-bottom: none;
  font-weight: 600;
  font-size: 12px;
  color: #111111;
}

::v-deep .popover-body {
  background-color: #ffffff;
  font-weight: 400;
  font-size: 12px;
  color: #9d9d9d;
}
</style>
